import Icon from "Components/Icon";

import RainfallImg from "Assets/Images/trfficAnalysis/events/rainfall.svg";
import FractureImg from "Assets/Images/trfficAnalysis/events/fracture.svg";
import AccidentImg from "Assets/Images/trfficAnalysis/events/accident.svg";
import FallingImg from "Assets/Images/trfficAnalysis/events/falling.svg";
import DeathImg from "Assets/Images/trfficAnalysis/events/death.svg";
import RainfallImgWhite from "Assets/Images/trfficAnalysis/events/white/rainfall-white.svg";
import FractureImgWhite from "Assets/Images/trfficAnalysis/events/white/fracture-white.svg";
import AccidentImgWhite from "Assets/Images/trfficAnalysis/events/white/accident-white.svg";
import FallingImgWhite from "Assets/Images/trfficAnalysis/events/white/falling-white.svg";
import DeathImgWhite from "Assets/Images/trfficAnalysis/events/white/death-white.svg";

import TruckImg from "Assets/Images/trfficAnalysis/waybill/truck.svg";
import TrailerImg from "Assets/Images/trfficAnalysis/waybill/trailer.svg";
import TruckImgWhite from "Assets/Images/trfficAnalysis/waybill/white/truck-white.svg";
import TrailerImgWhite from "Assets/Images/trfficAnalysis/waybill/white/trailer-white.svg";

export const PLAQUE_ALPHABET = [
  { value: "01", text: "الف" },
  { value: "02", text: "ب" },
  { value: "03", text: "پ" },
  { value: "04", text: "ت" },
  { value: "05", text: "ث" },
  { value: "06", text: "ج" },
  { value: "07", text: "چ" },
  { value: "08", text: "ح" },
  { value: "09", text: "خ" },
  { value: "10", text: "د" },
  { value: "11", text: "ذ" },
  { value: "12", text: "ر" },
  { value: "13", text: "ز" },
  { value: "14", text: "ژ" },
  { value: "15", text: "س" },
  { value: "16", text: "ش" },
  { value: "17", text: "ص" },
  { value: "18", text: "ض" },
  { value: "19", text: "ط" },
  { value: "20", text: "ظ" },
  { value: "21", text: "ع" },
  { value: "22", text: "غ" },
  { value: "23", text: "ف" },
  { value: "24", text: "ق" },
  { value: "25", text: "ک" },
  { value: "26", text: "گ" },
  { value: "27", text: "ل" },
  { value: "28", text: "م" },
  { value: "29", text: "ن" },
  { value: "30", text: "و" },
  { value: "31", text: "ه" },
  { value: "32", text: "ی" },
];

export const EVENTS_TYPES = [
  { type: "تصادف جرحی", text: "تصادف جرحی", imgSrc: FractureImg, whiteImgSrc: FractureImgWhite },
  { type: "تصادف خسارتی", text: "تصادف خسارتی", imgSrc: AccidentImg, whiteImgSrc: AccidentImgWhite },
  { type: "تصادف با عابر", text: "تصادف با عابر", imgSrc: FallingImg, whiteImgSrc: FallingImgWhite },
  { type: "آبگرفتگی", text: "آبگرفتگی", imgSrc: RainfallImg, whiteImgSrc: RainfallImgWhite },
  { type: "تصادف فوتی", text: "تصادف فوتی", imgSrc: DeathImg, whiteImgSrc: DeathImgWhite },
];

export const WAYBILL_TYPES = [
  { type: "سنگین", text: "سنگین", imgSrc: TrailerImg, whiteImgSrc: TrailerImgWhite },
  { type: "سبک", text: "سبک", imgSrc: TruckImg, whiteImgSrc: TruckImgWhite },
];
